import classNames from 'classnames';
import React, {useState} from 'react';

import CollapserChevron from 'ui-library/CollapserChevron';
import {WHITE, GRAY_LIGHTER} from 'ui-library/Colors';
import {ElementMouseEvent} from 'util/Types';

type HeaderColor = typeof WHITE | typeof GRAY_LIGHTER;

export interface CollapsibleCardProps {
  children: React.ReactNode;
  leftHeader: React.ReactNode;
  initiallyExpanded?: boolean;
  isCollapsible?: boolean;
  rightHeader?: React.ReactNode;
  headerColor?: HeaderColor;
}

export default function CollapsibleCard({
  children,
  leftHeader,
  initiallyExpanded = true,
  isCollapsible,
  rightHeader,
  headerColor = GRAY_LIGHTER,
}: CollapsibleCardProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(initiallyExpanded);
  const expand = isExpanded || isCollapsible === false; // explicitly false, not just undefined
  return (
    <div
      className={classNames('collapsibleCard', {
        'collapsibleCard--isExpanded': expand,
      })}
    >
      <div
        style={{backgroundColor: headerColor}}
        className={classNames('collapsibleCard-header u-pointer')}
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <div>{leftHeader}</div>
        {(rightHeader || isCollapsible !== false) && (
          <div className="u-flex-none">
            {rightHeader && <div className="u-display-inline-block u-small-spacing-right">{rightHeader}</div>}
            {isCollapsible !== false && (
              <CollapserChevron
                isExpanded={isExpanded}
                // Display only 'collapse' and 'expand' in alt text
                name=""
                onToggleCollapsed={(e: ElementMouseEvent) => {
                  e.stopPropagation();
                  setIsExpanded(!isExpanded);
                }}
              />
            )}
          </div>
        )}
      </div>
      {expand && <div className="collapsibleCard-body">{children}</div>}
    </div>
  );
}
